const TAB_INSTANCE_QUERY_KEY = '__tab';

export { TAB_INSTANCE_QUERY_KEY };

export const createTabInstanceId = () => {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
};

export const getTabInstanceIdFromQuery = (query?: Record<string, any>) => {
  const value = query?.[TAB_INSTANCE_QUERY_KEY];
  if (Array.isArray(value)) {
    return value[0] ? String(value[0]) : '';
  }
  return value ? String(value) : '';
};

export const stripTabInstanceQuery = (query?: Record<string, any>) => {
  if (!query) return {};
  const nextQuery = { ...query };
  delete nextQuery[TAB_INSTANCE_QUERY_KEY];
  return nextQuery;
};

export const createTabInstanceQuery = (query?: Record<string, any>) => {
  return {
    ...stripTabInstanceQuery(query),
    [TAB_INSTANCE_QUERY_KEY]: createTabInstanceId(),
  };
};

export const getRouteTabKey = (routeLike: {
  fullPath?: string;
  query?: Record<string, any>;
}) => {
  return getTabInstanceIdFromQuery(routeLike.query) || String(routeLike.fullPath || '');
};
